import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// Disputed stock waiting for logistics to rule on it.

export function useStockDisputes() {
  return useQuery({
    queryKey: ['stock-disputes'],
    queryFn: async () => (await api.get('/api/stock-borrows/disputes')).data,
    // this is a work queue — a stale one means two people rule on the same thing
    staleTime: 0,
    retry: false,
  });
}

export function useFleetVans() {
  return useQuery({
    queryKey: ['stock-disputes', 'vans'],
    queryFn: async () => (await api.get('/api/stock-borrows/vans')).data.vans,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useResolveDispute(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body) => (await api.post(`/api/stock-borrows/${id}/resolve`, body)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stock-disputes'] }),
  });
}

// The other kind: the storeman handed stock over and the engineer says what he
// was given is not what the order says. Same queue for logistics, different
// record — these live on the van stock request itself. Nothing moved when it
// was raised: the stock is on his van either way, which is why settling one is
// a note rather than a stock correction.
export function useHandoverDisputes() {
  return useQuery({
    queryKey: ['stock-disputes', 'handovers'],
    queryFn: async () => (await api.get('/api/van-requests/storeroom/disputes')).data.disputes,
    staleTime: 0,
    retry: false,
  });
}

export function useResolveHandoverDispute() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, resolution }) =>
      (await api.post(`/api/van-requests/${id}/dispute/resolve`, { resolution })).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['stock-disputes'] }),
  });
}
